import Component from './Component';
import operations from './operations';
import { deserialize, serialize } from './serialize';
import { type, isEmbed } from './shared';
import slashMenu from './slashMenu';

export default {
  deserialize,
  isEmbed,
  isVoid: true,
  Component,
  operations,
  renderNode: Component,
  serialize,
  slashMenu,
  type,
};
